import { CarWheelSetSeasonDistribution, TireSeason } from '@navio/nsdk';

export const STORED_WHEEL_SET_SEASONS = [TireSeason.SUMMER, TireSeason.WINTER] as const;

/** Sums every entry for the season, so counts from several locations can be passed flattened. */
export const getWheelSetSeasonCount = (counts: CarWheelSetSeasonDistribution[], season: TireSeason): number =>
  counts.reduce((total, item) => (item.season.value === season ? total + item.count : total), 0);

/** Whether a storage location holds anything, so it cannot be deleted yet. */
export const hasStoredItems = ({
  wheelSetCounts,
  tireCount
}: {
  wheelSetCounts: CarWheelSetSeasonDistribution[];
  tireCount: number;
}): boolean => tireCount > 0 || wheelSetCounts.some(({ count }) => count > 0);
